// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  //apiUrl: 'http://127.0.0.1:8000/'
  //apiUrl: 'http://localhost/api/'
  //apiUrl: 'http://172.16.7.91/api/'
  //apiUrl: 'http://172.16.7.98/api/'
  apiUrl :'https://pmsdevadmin.cstep.in/'
  //apiUrl :'https://pmsadmin.cstep.in/'
};
